import React from 'react';
import Screen from './container';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ConfigProvider } from 'antd';

import theme from './theme';
import './theme/index.css';
import { NotificationProvider } from './hooks/useNotification';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const clientId: string = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '';
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <ConfigProvider theme={theme}>
        <Provider store={store}>
          <NotificationProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Screen />
            </BrowserRouter>
          </NotificationProvider>
        </Provider>
      </ConfigProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
